// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node_modules-\\@vibrent-electryon-dist-components-phoneNumberView-styles__phone-view-wrapper--3HzrFosn{display:inline-flex}.node_modules-\\@vibrent-electryon-dist-components-phoneNumberView-styles__phone-view-wrapper--3HzrFosn a{cursor:pointer !important}.node_modules-\\@vibrent-electryon-dist-components-phoneNumberView-styles__phone-view-wrapper--3HzrFosn .outdated{color:#bf0030}", ""]);
// Exports
exports.locals = {
	"phone-view-wrapper": "node_modules-@vibrent-electryon-dist-components-phoneNumberView-styles__phone-view-wrapper--3HzrFosn"
};
module.exports = exports;
